export default __webpack_public_path__ + "478d3701b5d61fecdcdbc176a713cf66.png";